// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const PublicHeader: React.FC = () => {
  const navigate = useNavigate();
  const { isDark, toggleTheme } = useTheme();

  return (
    <nav className={`sticky top-0 z-50 backdrop-blur transition-colors duration-200 ${
      isDark
        ? 'supports-[backdrop-filter]:bg-black/30 bg-black/20 border-b border-white/10'
        : 'bg-white/95 border-b border-gray-200 shadow-sm'
    }`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <img src="/investverse-logo.svg" alt="InvestVerse.AI" className="h-8 w-auto" />
          </button>

          {/* Right Side - Theme Toggle & CTA */}
          <div className="flex items-center gap-3">
            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className={`p-2 rounded-xl transition-all duration-200 ${
                isDark
                  ? 'border border-white/10 hover:bg-white/10'
                  : 'border border-gray-200 hover:bg-gray-100'
              }`}
              aria-label="Toggle theme"
            >
              {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            </button>

            {/* Get Started Button */}
            <button
              onClick={() => navigate('/')}
              className={`px-4 py-2 rounded-xl font-medium text-sm transition-all duration-200 ${
                isDark
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicHeader;
